// Import database API
import {
    generateVisitId,
    getVisitPerDayCount as databaseGetVisitPerDayCount,
    getViewPerProductCount as databaseGetViewPerProductCount,
    getViewPerLocationCount as databaseGetViewPerLocationCount,
    logVisit,
    logProductView as databaseLogProductView,
} from '../database/endpoints/log.api';

// ------------------------------------------------------------------------------
// GETTER
// ------------------------------------------------------------------------------
// Function to get a table containing visit per day count
export async function getVisitPerDayCount() {
    try {
        // Get visit logs
        return await databaseGetVisitPerDayCount();
    } catch (err) {
        console.error(
            `Error while loading visit log\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to get a table containing view per product count
export async function getViewPerProductCount() {
    try {
        // Get view per product logs
        return await databaseGetViewPerProductCount();
    } catch (err) {
        console.error(
            `Error while loading view per product log\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to get a table containing visit per location count
export async function getViewPerLocationCount() {
    try {
        // Get visit per location logs
        return await databaseGetViewPerLocationCount();
    } catch (err) {
        console.error(
            `Error while loading visit per location log\nError message: ${err.message}`,
        );
        throw err;
    }
}

// ------------------------------------------------------------------------------
// LOGGER
// ------------------------------------------------------------------------------

// Function to initiate a new visit
export async function initVisit() {
    // Get the visit from local storage if it exist
    const storedVisitId = sessionStorage?.getItem('visit_id') ?? null;

    // If the visit as already been initiated
    if (storedVisitId) return storedVisitId;

    try {
        // try to generate a new visit id, log it in the db and set it up
        // in the local storage
        const visitId = await generateVisitId();
        await logVisit(visitId);
        sessionStorage.setItem('visit_id', visitId);
        return visitId;
    } catch (err) {
        sessionStorage.removeItem('visit_id');
        console.error(
            `Error while initiating the visit\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to log a product view
export async function logProductView(visitId, productId) {
    try {
        // Try to log the product view
        await databaseLogProductView(visitId, productId);
    } catch (err) {
        console.error(
            `Error while logging the product view for product with id: ${productId}\nError message: ${err.message}`,
        );
        throw err;
    }
}
